import {FC, HTMLAttributes} from "react";
import logo from '../../assets/nps/images/logo.png';
import css from './HeaderLogo.module.scss'
import classNames from 'classnames/bind';

const cx = classNames.bind(css);

const HeaderLogo: FC<HTMLAttributes<HTMLDivElement>> = ({className}) => {
    return (
        <header>
            <div className={cx(css.header, className)}>
                <img className={css.header__logo} alt="jooble_logo" src={logo}/>
            </div>
        </header>
    )
}

export default HeaderLogo;